module.exports = __webpack_public_path__ + "static/media/loading_blue.54c18b91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/loading_blue.svg
// module id = 1176
// module chunks = 0